import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

export const useGetAllSpotlightVideos = () => {
  const mutate = useMutation(() => {
    return get(`/enterprise-media-api/get_spotlight_videos`);
  });

  return mutate;
};

export default useGetAllSpotlightVideos;
